import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { CasesRepository } from '../../../infrastructure/repositories/cases.repository';
import { CasesState } from '../../states/cases.state';
import { GetCasesListQuery } from './get-cases-list.query';
import { GetCasesListResult } from './get-cases-list.result';

/**
 * Get cases list use case.
 * Retrieves all cases as summary data (for dropdowns, list views).
 */
@Injectable({ providedIn: 'root' })
export class GetCasesListUseCase {
  private readonly _repository = inject(CasesRepository);
  private readonly _state = inject(CasesState);

  public execute(_query: GetCasesListQuery): Observable<GetCasesListResult> {
    this._state.setLoadingCasesList(true);
    this._state.setErrorCasesList(null);

    return this._repository.getCasesList().pipe(
      tap((casesList) => {
        this._state.setCasesList(casesList);
        this._state.setLoadingCasesList(false);
      }),
      map((casesList) => ({ casesList })),
      catchError((error) => {
        this._state.setErrorCasesList(error.message || 'Failed to get cases list');
        this._state.setLoadingCasesList(false);
        return throwError(() => error);
      })
    );
  }
}
